import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Container, Box, Center, Spinner } from "@chakra-ui/react";
import CommonHeader from "../FormCreation/Header";
import FormList from "./FormList";
import { getTemplate as getPreviewTemplate } from "../../api/shortcodeTemplateApi";
import { getTemplates } from "../../api/templateApi";
import {
  getFormSubmissions,
  deleteFormSubmission_Bulk,
} from "../../api/formSubmissionApi";
import { defaultTemplates } from "../ChooseTemplate/defaultTemplates.json";
import ModalFormPreview from "../Common/ModalFormPreview";
import FormPreview from "../FormPreview";
import Header from "./Header";
import SubmissionView from "./SubmissionView";
const FormListPage = ({
  currentTemplate,
  location: { formId },
  isTemplateDeleted,
}) => {
  const [formSubmissions, setFormSubmissions] = useState(null);
  const [selectFormSubmissions, setSelectFormSubmissions] = useState([]);
  const [selectFormId, setSelectFormId] = useState(formId);
  const [templates, setTemplates] = useState([]);
  const [previewMode, setPreviewMode] = useState(false);
  const [detailsView, setDetailsView] = useState(false);
  const [actionId, setActionId] = useState(null);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [previewTemplateId, setPreviewTemplateId] = useState(null);
  const [redirectChooseTemplate, setRedirectChooseTemplate] = useState(null);
  const [allChecked, setAllChecked] = useState(false);
  const [isChecked, setIsChecked] = useState({});
  const [selectValue, setSelectValue] = useState("");
  const data = {};
  const [formData, setFormData] = useState([]);
  const [deleteList, setDeleteList] = useState([]);
  const [shouldDelete, setShouldDelete] = useState(false);

  const onClickPreviewHandler = (id) => {
    setPreviewMode(true);
    setPreviewTemplateId(id);
  };

  const onRedirectHandler = (e) => {
    e.preventDefault();
    setDetailsView(!detailsView);
    setActionId(null);
  };

  const handleAction = (id, type = "edit") => {
    if (type == "view") {
      setDetailsView(true);
      setActionId(id);
    } else {
      const newSelectFormSubmissions = selectFormSubmissions.filter(
        (submission) => {
          return submission.id != id;
        }
      );
      setSelectFormSubmissions(newSelectFormSubmissions);
    }
  };

  const addFormHandler = (e) => {
    e.preventDefault();
    setRedirectChooseTemplate(true);
  };

  const handlePreviewModeClose = (onClose) => {
    setPreviewMode((isToggled) => !isToggled);
    setPreviewTemplate(() => null);
    onClose();
  };

  const onChangeFormHandler = (formId) => {
    setSelectFormId(formId);
    const selectFormSubmissions = formSubmissions.filter((submission) => {
      return submission.formId == formId;
    });
    setSelectFormSubmissions(selectFormSubmissions);
  };

  const onChangeEvent = (e) => {
    setSelectValue(e.target.value);
  };

  const onClickEvent = () => {
    const makeDeleteList = allChecked ? formData : isChecked;
    const deleteListIds = [];
    for (const list in makeDeleteList) {
      makeDeleteList[list] && deleteListIds.push(list);
    }
    setDeleteList(deleteListIds);
    if (deleteListIds.length && selectValue == "delete") {
      setShouldDelete(true);
    }
  };

  useEffect(() => {
    if (shouldDelete) {
      deleteFormSubmission_Bulk(deleteList)
        .then((data) => {
          let new_submissions = Object.values(data);
          setFormSubmissions(new_submissions);
          const selectFormSubmissions = new_submissions.filter((submission) => {
            return submission.formId == selectFormId;
          });
          setSelectFormSubmissions(selectFormSubmissions);
          setShouldDelete(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [shouldDelete]);
  console.log(
    "<<<<<<<<<<<<<<<<<<<<<<<<<<<<<>>>>>>>>>>>>>>>>>>>>>>>>>>>>> use effect 2",
    formSubmissions
  );
  useEffect(() => {
    const apiUrl = `http://localhost/wordpress/wp-json`;
    const nonce = `5c74968270`;
    if (previewMode) {
      getPreviewTemplate(previewTemplateId,  window.appLocalizer) //{ apiUrl, nonce } window.appLocalizer
        .then((template) => {
          console.log(template);
          setPreviewTemplate(() => ({ ...template }));
        })
        .catch((err) => {
          if (previewTemplateId.includes("default")) {
            const template = defaultTemplates.find(
              (template) => previewTemplateId == template.id
            );
            setPreviewTemplate(() => ({ ...template }));
          }
          throw err;
        });
    }
  }, [previewMode]);

  useEffect(() => {
    if (!formSubmissions)
      Promise.all([getFormSubmissions(), getTemplates()]).then((payload) => {
        console.log(
          "🚀 ~ file: index.js ~ line 59 ~ Promise.all ~ payload",
          payload
        );
        const [formSubmissions, templates] = payload;

        let formSubmissionsArrayconvert =
          formSubmissions instanceof Array
            ? formSubmissions
            : Object.values(formSubmissions);
        const selectFormSubmissions = formSubmissionsArrayconvert.filter(
          (submission) => {
            return submission.formId == selectFormId;
          }
        );
        setFormSubmissions(formSubmissionsArrayconvert);
        setSelectFormSubmissions(selectFormSubmissions);
        setTemplates(templates);

        selectFormSubmissions.length &&
          selectFormSubmissions.map(({ id }) => (data[id] = false));
        setFormData(data);
      });
  }, []);

  const onChangeCheckBox = (e, id) => {
    const checkedValue = e.target.checked;
    id != "mainCheckBox" && setIsChecked({ ...isChecked, [id]: checkedValue });
    if (id == "mainCheckBox") {
      selectFormSubmissions.map(({ id }) => (data[id] = e.target.checked));
      setAllChecked(e.target.checked), setFormData(data);
    }
  };

  const renderPreviewForm = () => {
    if (previewMode && !previewTemplate) {
      return (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      );
    }
    return previewMode && previewTemplate ? (
      <ModalFormPreview
        shouldOpen={previewMode}
        handlePreviewModeClose={handlePreviewModeClose}
      >
        <FormPreview template={previewTemplate} />
      </ModalFormPreview>
    ) : null;
  };
  return (
    <Container w="100%" h="100vh" maxW="100%" p="0" bg="#F0F0F1">
      {!formSubmissions && (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      )}
      {renderPreviewForm()}
      {redirectChooseTemplate && <Redirect to="choose-template" />}
      {currentTemplate && currentTemplate.id && <Redirect to="dashboard" />}
      <CommonHeader type="entries" handleOnClick={addFormHandler} />
      {templates.length && (
        <Header
          onChangeFormHandler={onChangeFormHandler}
          selectFormId={selectFormId}
          templates={templates}
        />
      )}
      <Box p="1rem">
        {/* <Header /> */}
        {detailsView ? (
          <SubmissionView
            onRedirectHandler={onRedirectHandler}
            submissionId={actionId}
          />
        ) : (
          <FormList
            formSubmissions={selectFormSubmissions}
            handleAction={handleAction}
            isChecked={isChecked}
            allChecked={allChecked}
            selectValue={selectValue}
            onChangeCheckBox={onChangeCheckBox}
            onChangeEvent={onChangeEvent}
            onClickEvent={onClickEvent}
          />
        )}
        {/* <Footer /> */}
      </Box>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    currentTemplate: state.templates.currentTemplate,
    isTemplateDeleted: state.templates.deleted,
  };
};

export default connect(mapStateToProps, null)(FormListPage);
